const RE = /^(\d+)\.(\d+)\.(\d+)/;

export const PolicyVersion = {
  compare(a, b) {
    const pa = a.match(RE), pb = b.match(RE);
    if (!pa || !pb) throw new Error(`Invalid semver: ${a} vs ${b}`);
    for (let i = 1; i <= 3; i++) {
      const da = +pa[i], db = +pb[i];
      if (da !== db) return da < db ? -1 : 1;
    }
    return 0;
  },
  needsReprompt(stored, current) {
    if (!stored) return true;
    return this.compare(stored, current) < 0;
  },
};
